export const toBufferInt = (v: string | null): number | null => {
  if (!v) return null
  const n = parseInt(v, 10)
  return isNaN(n) ? null : n
}
